import React, { useState } from 'react';
import Modal from "./Modal";

const AllowQRCodeBanks = [
  {bankName:"ธ.ออมสิน", suffixClass:"THEGOVERNMENTSAVINGBANK"},
  {bankName:"ธ.กรุงเทพ", suffixClass:"BANGKOKBANK"},
  {bankName:"ธ.กรุงไทย", suffixClass:"KRUNGTHAIBANK"},
  {bankName:"ธ.กรุงศรีอยุธยา", suffixClass:"BANKOFAYUDHAYAPUBLICCOMPANYLTD"},
  {bankName:"ธ.กสิกรไทย", suffixClass:"KASIKORNBANK"},
  {bankName:"ธ.ไทยพาณิชย์", suffixClass:"SIAMCOMMERCIALBANK"},
  {bankName:"ธ.ทหารไทยฯ", suffixClass:"TMBTHANACHARTBANK"},
  {bankName:"ธ.เกียรตินาคิน", suffixClass:"KIATNAKINBANKPCL"},
  {bankName:"ธ.ทิสโก้", suffixClass:"TISCOBANKPCL"},
  {bankName:"ธ.ธนชาต", suffixClass:"THANACHARTBANK"},
  {bankName:"ธ.นครหลวงไทย", suffixClass:"IDONTKNOW"},
  {bankName:"ธ.ยูโอบี", suffixClass:"UNITEDOVERSEASBANKTHAIPUBLICCOMPANYLTD"},
  {bankName:"ธ.สแตนดาร์ด\nชาร์เตอร์", suffixClass:"STANDARDCHARTEREDBANKTHAIPCL"},
  {bankName:"ธ.ซีไอเอ็มบี", suffixClass:"CIMBTHAIBANKPUBLICCOMPANYLTD"},
  {bankName:"ธ.ไอซีบี", suffixClass:"INDUSTRIALANDCOMMERCIALBANKOFCHINATHAIPCL"},
  {bankName:"ธ.LH", suffixClass:"LANDANDHOUSESBANK"},
  {bankName:"ธ.ธ.ก.ส", suffixClass:"BANKFORAGRICULTUREANDAGRICULTURALCOOPERATIVES"},
]

function AllowQRCodeBanksModal(props){
  const [visible, setVisible] = useState(false);
  return (
    <>
      <p className='seeAllBanksAllowQRCode' onClick={() => { setVisible(true) }}>รายชื่อธนาคารที่สามารถฝากเงิน QR Code ได้</p>
      <Modal
        className='qrCodeBanksModal'
        title="รายชื่อธนาคารที่สามารถฝากเงิน QR Code ได้"
        visible={visible}
        onlyOkBtn={true}
        okText="ปิด"
        onOk = {() => { setVisible(false) }}
      >
        <div className="allowQRCodeBankList">
          {AllowQRCodeBanks.map(item=>{
            return(
              <div className="bankItem">
                <div className={`bankIcon-default bankIcon-${item.suffixClass}`} />
                <label>{item.bankName}</label>
              </div>
            )
          })}   
        </div> 
      </Modal>
    </>
  )

}

export default AllowQRCodeBanksModal;

